(function(){
  var dsAttr = function(type, options){
    return Em.computed(function(_,value){
      if (typeof(value) !== 'undefined') {
        return value;
      }
      return options.defaultValue || '';
    }).property();
  };

  PegasusTemplate.CaptureTemplateWidgetAttributesMixin = Em.Mixin.create({
    dataWidth: dsAttr('string', { defaultValue: '' }),
    dataHeight: dsAttr('string', { defaultValue: '' }),
    dataAlignment: dsAttr('string', { defaultValue: 'center' }),
    dataShouldScale: dsAttr('string', { defaultValue: 'true' }),
    dataShouldOverflow: dsAttr('string', { defaultValue: 'false' }),
  });

  PegasusTemplate.CaptureTemplateFormAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataTarget: dsAttr('string', { defaultValue: '' }),
    dataFieldOrder: dsAttr('string', { defaultValue: '' }),
    dataFormName: dsAttr('string', { defaultValue: ''}),
    dataFormListId: dsAttr('string', { defaultValue: ''})
  });

  PegasusTemplate.WebTemplateWidgetAttributesMixin = Em.Mixin.create({
    dataWidth: dsAttr('string', { defaultValue: '' }),
    dataHeight: dsAttr('string', { defaultValue: '' }),
    dataAlignment: dsAttr('string', { defaultValue: 'center' }),
    dataShouldScale: dsAttr('string', { defaultValue: 'true' }),
    dataShouldOverflow: dsAttr('string', { defaultValue: 'false' }),
  });

  PegasusTemplate.WebTemplateFormAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataTarget: dsAttr('string', { defaultValue: '' }),
    dataFieldOrder: dsAttr('string', { defaultValue: '' }),
    dataFormName: dsAttr('string', { defaultValue: ''}),
    dataFormListId: dsAttr('string', { defaultValue: ''})
  });

  PegasusTemplate.TextAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    html: dsAttr('string', {defaultValue: ''}),
    dataLineHeight:  dsAttr('string', {defaultValue: '100'}),
    dataBackground:  dsAttr('string', {defaultValue: ''}),
    dataBorderColor:  dsAttr('string', {defaultValue: ''}),
    dataMargin:  dsAttr('string', {defaultValue: '0 0 9px 0'}),
    dataBorderStyle:  dsAttr('string', {defaultValue: 'Solid'}),
    dataBorderWidth:  dsAttr('string', {defaultValue: '0'}),
    dataBorderTopMargin:  dsAttr('string', {defaultValue: '0'}),
    dataBorderRightMargin:  dsAttr('string', {defaultValue: '0'}),
    dataBorderBottomMargin:  dsAttr('string', {defaultValue: '0'}),
    dataBorderLeftMargin:  dsAttr('string', {defaultValue: '0'})
  });

  PegasusTemplate.SocialShareAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataHideLabel: dsAttr('boolean', {defaultValue: "false"}),
    dataBorderRadius:  dsAttr('string', {defaultValue: '0'}),
    dataBorderTopPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderRightPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderBottomPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderLeftPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderColor:  dsAttr('string', {defaultValue: ''}),
    dataBorderStyle:  dsAttr('string', {defaultValue: 'Solid'}),
    dataBorderWidth:  dsAttr('string', {defaultValue: '0'}),
    dataAlignment: dsAttr('string', {defaultValue: 'center'}),
    dataStyleGroup: dsAttr('string', {defaultValue: 'classic'})
  });

  PegasusTemplate.DividerAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataHeight: dsAttr('string', {defaultValue: '1'}),
    dataBorderStyle:  dsAttr('string', {defaultValue: 'Solid'}),
    dataBorderTopPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderBottomPadding:  dsAttr('string', {defaultValue: '0'}),
    dataAlignment: dsAttr('string', {defaultValue: 'center'}),
    dataBackground: dsAttr('string', {defaultValue: ''}),
    dataWidth: dsAttr('string', {defaultValue: '84'})
  });

  PegasusTemplate.HorizontalStaticSpaceAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataWidth: dsAttr('string', {defaultValue: '1'})
  });

  PegasusTemplate.VerticalStaticSpaceAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataHeight: dsAttr('string', {defaultValue: '1'})
  });

  PegasusTemplate.ButtonAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataAlignment: dsAttr('string', {defaultValue: 'center'}),
    dataStyleGroup: dsAttr('string', {defaultValue: 'styleGroup2'}),
    dataBackground:  dsAttr('string', {defaultValue: ''}),
    dataBorderColor:  dsAttr('string', {defaultValue: ''}),
    dataColor:  dsAttr('string', {defaultValue: ''}),
    dataBorderRadius: dsAttr('string', {defaultValue: '0'}),
    dataLinkType: dsAttr('string', { defaultValue: 'Website' }),
    dataLinkUrl: dsAttr('string', { defaultValue: ''}),
    dataLabel: dsAttr('string', { defaultValue: 'Click here'}),
    dataFontSize: dsAttr('string', { defaultValue: '14'}),
    dataBold: dsAttr('string', { defaultValue: 'false'}),
    dataItalic: dsAttr('string', { defaultValue: 'false'}),

    dataBorderWidth:  dsAttr('string', {defaultValue: '1'}),
    dataHeight:  dsAttr('string', {defaultValue: '0'}),
    dataWidth:  dsAttr('string', {defaultValue: '0'})
  });

  PegasusTemplate.SocialFollowAttributesMixin = Em.Mixin.create({
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataImageMargin: dsAttr('string', {defaultValue: '5'}),
    dataImageWidth: dsAttr('string', {defaultValue: ''}),
    dataHideLabel: dsAttr('boolean', {defaultValue: "false"}),
    dataBorderRadius:  dsAttr('string', {defaultValue: '0'}),
    dataBorderTopPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderRightPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderBottomPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderLeftPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderColor:  dsAttr('string', {defaultValue: ''}),
    dataBorderStyle:  dsAttr('string', {defaultValue: 'Solid'}),
    dataBorderWidth:  dsAttr('string', {defaultValue: '0'}),
    dataAlignment: dsAttr('string', {defaultValue: 'center'}),
    dataStyleGroup: dsAttr('string', {defaultValue: 'styleGroup2'}),
    dataNetworkOrder: dsAttr('string', {
      defaultValue: 'twitter,facebook'
    })
  });
})();
